import * as Yup from "yup";
import { SUBMIT_TYPES } from "src/utils/constants";
import validationMessages from "../../utils/validationMessages";

const allAttachmentsAttributes = {
  attachments: Yup.array().test(
    "chosen files has errors",
    validationMessages.filesHasErrors(),
    (files) => !files?.length || !files.some((file) => file.errors),
  ),
};

const ValidationSchema = Yup.object().shape({
  patientFullname: Yup.string().when("submitType", {
    is: (submitType) => submitType === SUBMIT_TYPES.COMPLETE,
    then: Yup.string().required(validationMessages.requiredField()),
    otherwise: Yup.string(),
  }),
  patientId: Yup.string(),
  patientAge: Yup.number()
    .nullable()
    .transform((value, originalValue) => (
      originalValue === "" || originalValue === null || typeof originalValue === "undefined"
        ? null
        : value
    ))
    .min(1, validationMessages.minNumber(1)),
  patientClinicalData: Yup.string().when("submitType", {
    is: (submitType) => submitType === SUBMIT_TYPES.COMPLETE,
    then: Yup.string().required(validationMessages.requiredField()),
    otherwise: Yup.string(),
  }),
  patientGender: Yup.string().when("submitType", {
    is: (submitType) => submitType === SUBMIT_TYPES.COMPLETE,
    then: Yup.string().required(validationMessages.requiredField()),
    otherwise: Yup.string(),
  }),
  urgency: Yup.string().when("submitType", {
    is: (submitType) => submitType === SUBMIT_TYPES.COMPLETE,
    then: Yup.string().required(validationMessages.requiredField()),
    otherwise: Yup.string(),
  }),
  modalityId: Yup.object().required(validationMessages.requiredField()),
  examTypeId: Yup.object().required(validationMessages.requiredField()),
  // Must declare these in the schema so .when() can resolve them in Yup 0.x
  dicomRadio: Yup.string(),
  // existingDicom: true when the draft record already has a valid DICOM on the server
  existingDicom: Yup.boolean(),
  // DICOM URL: required and valid URL when dicomRadio is 'Url' AND completing the request
  // (skip if an existing DICOM is already on the record)
  dicom: Yup.string().when(["dicomRadio", "submitType", "existingDicom"], {
    is: (dicomRadio, submitType, existingDicom) => dicomRadio === "Url" && submitType === SUBMIT_TYPES.COMPLETE && !existingDicom,
    then: Yup.string()
      .url(validationMessages.invalid("URL"))
      .required(validationMessages.requiredField()),
    otherwise: Yup.string().when("dicomRadio", {
      is: "Url",
      then: Yup.string().url(validationMessages.invalid("URL")),
      otherwise: Yup.string(),
    }),
  }),
  // DICOM file: required when dicomRadio is 'File' AND completing the request
  // (skip if an existing DICOM is already on the record)
  // eslint-disable-next-line react/forbid-prop-types
  attachmentsAttributes: Yup.object().when(
    ["dicomRadio", "submitType", "existingDicom"],
    {
      is: (dicomRadio, submitType, existingDicom) => dicomRadio === "File" && submitType === SUBMIT_TYPES.COMPLETE && !existingDicom,
      then: Yup.object({
        ...allAttachmentsAttributes,
        dicom: Yup.mixed()
          .test(
            "dicom-file-has-errors",
            validationMessages.fileHasErrors(),
            (file) => !file || !file.errors,
          )
          .required(validationMessages.requiredField()),
      }),
      otherwise: Yup.object(allAttachmentsAttributes),
    },
  ),
});

export default ValidationSchema;
